{
    "Accessibility Menu": "Menu ng Pag-access",
    "Reset settings": "I-reset ang mga setting",
    "Close": "Isara",
    "Content Adjustments": "Mga Pag-aayos ng Nilalaman",
    "Adjust Font Size": "Ayusin ang Laki ng Font",
    "Highlight Title": "I-highlight ang Pamagat",
    "Highlight Links": "I-highlight ang mga Link",
    "Readable Font": "Font na Madaling Basahin",
    "Color Adjustments": "Mga Pag-aayos ng Kulay",
    "Dark Contrast": "Madilim na Contrast",
    "Light Contrast": "Maliwanag na Contrast",
    "High Contrast": "Mataas na Contrast",
    "High Saturation": "Mataas na Saturation",
    "Low Saturation": "Mababang Saturation",
    "Monochrome": "Monochrome",
    "Protanopia": "Protanopia",
    "Deuteranopia": "Deuteranopia",
    "Tritanopia": "Tritanopia",
    "Visual & Navigation Aids": "Mga Tulong sa Paningin at Nabigasyon",
    "Additional Tools": "Karagdagang Mga Tool",
    "Reading Guide": "Gabay sa Pagbasa",
    "Stop Animations": "Itigil ang mga Animation",
    "Big Cursor": "Malaking Cursor",
    "Screen Reader": "Screen Reader",
    "Hide Images": "Itago ang mga Larawan",
    "Image Tooltips": "Tooltips ng Larawan",
    "Page Structure": "Istraktura ng Pahina",
    "Super Focus": "Super Focus",
    "Magnifier": "Magnipikador",
    "Increase Font Size": "Lakihan ang Font",
    "Decrease Font Size": "Liitan ang Font",
    "Letter Spacing": "Espasyo ng Titik",
    "Line Height": "Taas ng Linya",
    "Font Weight": "Bigat ng Font",
    "Dyslexia Font": "Font para sa Dyslexia",
    "Language": "Wika",
    "Open Accessibility Menu": "Buksan ang Menu ng Pag-access",
    "Accessibility Profiles": "Mga Profile ng Accessibility",
    "Seizure Safe Profile": "Profile na Ligtas para sa Seizure",
    "Stops animations and reduces color saturation.": "Ititigil ang mga animation at babawasan ang saturation ng kulay.",
    "Blind Profile": "Profile para sa mga Bulag",
    "Activates the screen reader for auditory navigation.": "Ino-activate ang screen reader para sa auditory navigation.",
    "Visually Impaired Profile": "Profile para sa may Kapansanan sa Paningin",
    "Enhances contrast and readability for low vision.": "Pinapabuti ang contrast at readability para sa mababang paningin.",
    "ADHD Friendly Profile": "Profile na Pabor sa ADHD",
    "Reduces distractions for better focus.": "Binabawasan ang mga distraksiyon para sa mas magandang pokus.",
    "Cognitive & Learning Profile": "Profile sa Kognitibo at Pagkatuto",
    "Helpful tools for reading and comprehension.": "Mga kapaki-pakinabang na tool para sa pagbabasa at pag-unawa.",
    "Motor Impaired Profile": "Profile para sa may Motor Impairment",
    "Optimizes the site for keyboard-only navigation.": "Ino-optimize ang site para sa navigasyon gamit lamang ang keyboard.",
    "Headings": "Mga Pamagat",
    "Landmarks": "Mga Landmark",
    "Links": "Mga Link",
    "Focus element": "I-focus ang elemento",
    "Visit link": "Bisitahin ang link"
}
